import React, {useState} from "react";
import NavItem from "./NavItem";
import NavToggle from "./NavToggle";
import cn from "classnames";
import styles from "./Navbar.module.scss";
import LazyImage from "../LazyImage/LazyImage";

interface NavItemType {
    id: number;
    title: string;
    link: string;
    disabled: boolean;
}

const navItems: NavItemType[] = [
    {
        id: 0,
        title: 'Преимущества',
        link: '#advantages',
        disabled: false,
    },
    {
        id: 1,
        title: 'Сервисы',
        link: '#services',
        disabled: false,
    },
    {
        id: 2,
        title: 'О нас',
        link: '#aboutus',
        disabled: false,
    },
    {
        id: 3,
        title: 'Контакты',
        link: '#contacts',
        disabled: false,
    },
];

const NavBar: React.FC = () => {
    const [activeLinkId, setActiveLinkId] = useState<number | null>(null);
    const [isNavOpen, setIsNavOpen] = useState<boolean>(false);

    const handleLinkClick = (id: number) => {
        setActiveLinkId(id);
    };

    const handleToggleNav = () => {
        setIsNavOpen((prev) => !prev);
    };

    return (
        <nav className={styles.navBar} aria-label="Навигация по сайту">

            <div className={styles.navBrand}>
                <LazyImage className="img-fluid" src="./assets/images/logos/alfaLogo.svg" alt="Свой Комфорт Trial"/>
            </div>

            <NavToggle onClick={handleToggleNav} isActive={isNavOpen}/>

            <ul className={cn(styles.navBarMenu, {
                [styles.active]: isNavOpen,
            })}>
                {navItems.map(item =>
                    <NavItem key={item.id}
                             {...item}
                             isActive={activeLinkId === item.id}
                             onClick={() => handleLinkClick(item.id)}
                    />
                )}
            </ul>
        </nav>
    )
}

export default NavBar;